








































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import sleep from '../../../utils/sleep';



@Component({
    components: {
    },
})
export default class LaptopVue extends Vue {

    // The code that solves the keypad
    @Prop({default: '123'})
    private code!: string;

    // Current code introduced
    private current: string = '';

    private has_error = false;

    // Key event
    press(){

        // If the code has all the characters, check it
        if(this.code.toLowerCase() !== this.current.toLowerCase()){
            this.show_error();
        } else {
            this.show_success();
        }

    }

    @Watch('current')
    changeCurrent(){
        this.has_error = false;
    }


    // Show an error
    async show_error(){
        console.log("has error");
        this.has_error = true;
    }

    // Show sucess and emit
    async show_success(){


        await sleep(1000);

        this.$emit('success');

    }


    enter(){
        if(!this.current) return;
        this.press();
    }


}

